import { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/theme/utils'

type Props = ComponentPropsWithoutRef<'div'> & {
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
  outerClassName?: string
}

const Radius = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  full: 'rounded-full',
} as const

export default function GradientWrapper({
  className,
  outerClassName,
  children,
  radius = 'lg',
  ...rest
}: Props) {
  return (
    <div
      {...rest}
      className={cn('overflow-hidden p-px', Radius[radius], outerClassName)}
      style={{
        background:
          'radial-gradient(24.92% 754.94% at 47.24% 319.4%,#000 0,#6686ff 100%)',
      }}
    >
      <div className={cn(Radius[radius], className)}>{children}</div>
    </div>
  )
}
